import {
	EditSensorDataSort,
	SensorDataPoint,
} from '@Types/editSensorData.types';

// Sort function for EditSensorDataPoints
export default function editSensorDataSort(
	data: SensorDataPoint[],
	sort?: EditSensorDataSort,
): SensorDataPoint[] {
	const { name, order } = sort || {};
	if (name === 'dataEditor-curValue') {
		return data.sort((a, b) =>
			order === 'desc'
				? b.value.doubleValue - a.value.doubleValue
				: a.value.doubleValue - b.value.doubleValue,
		);
	}
	// dataEditor-dateTime
	return data.sort((a, b) =>
		order === 'desc'
			? b.timestamp.timeInSeconds - a.timestamp.timeInSeconds
			: a.timestamp.timeInSeconds - b.timestamp.timeInSeconds,
	);
}
